import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpHandler, HttpClientModule } from '@angular/common/http';
import { TokenInterceptor } from './common/token.interceptor';
import { AuthService } from './login/auth.service';
import { JwtInterceptor } from './common/jwt.interceptor';
import { DashboardComponent } from './dashboard/dashboard.component';
import { Globals } from './common/Globals';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DashboardService } from './dashboard/dashboard.service';
import { HelperService } from './common/helper.service';
import { AgmCoreModule } from '@agm/core';
import { AgmOverlays } from "agm-overlays"
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ClickOutsideModule } from 'ng-click-outside';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { EditBoxComponent } from './common/components/edit-box/edit-box.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SortablejsModule } from 'angular-sortablejs';
import { TreeModule } from 'angular-tree-component';
import { environment } from 'src/environments/environment';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    EditBoxComponent
  ],
  imports: [
    TreeModule.forRoot(),
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule,
    AgmOverlays,
    AgmCoreModule.forRoot({
      apiKey: environment.googleApiKey
    }),
    AgmSnazzyInfoWindowModule,
    NgxUiLoaderModule,
    ClickOutsideModule,
    NgbModule,
    SortablejsModule.forRoot({
      animation: 150,
      ghostClass: 'sorting-ghost',
      forceFallback: true,
      fallbackClass: "sorting-dragged-item"
    })
  ],
  providers: [
    HttpClient,
    AuthService,
    DashboardService,
    HelperService,
    Globals,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
